<template>
  <default-layout>
    <section slot="content">
      <v-container fluid>
        <v-row class="mt-8">
          <v-col cols="12" lg="12" md="12" xs="12">
            <v-row>
              <v-col cols="12" md="6" xs="12">
                <v-select
                  v-model="groupSelected"
                  :items="select.groups"
                  item-value="id"
                  item-text="name"
                  label="Group"
                  dense
                  outlined
                ></v-select>
              </v-col>
              <v-col cols="12" md="6" xs="12">
                <v-select
                  v-model="orderBy"
                  :items="select.filters"
                  item-value="id"
                  item-text="name"
                  label="Ordenar por:"
                  dense
                  outlined
                  @change="findProduct"
                ></v-select>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col cols="6" md="3" sm="6" xs="6">
                <v-checkbox label="¿Desea visualizar el % de descuento en las imágenes generadas?" v-model="displayProductOff"></v-checkbox>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" lg="8" md="12" xs="12">
            <v-row>
              <template v-for="(item, index) in shownCards">
                <v-col
                  :ref="item.id"
                  :key="item.id"
                  cols="12"
                  lg="3"
                  md="4"
                  sm="6"
                  xs="12"
                >
                  <v-card style="border: 5px solid #1b74e4" outlined elevation="0">
                    <img :min-height="$vuetify.breakpoint.xsOnly ? 250 : 180" style="width: 100%;" :src="item.product_color_image[0].image" :key="item.product_color_image[0].image">
                    <v-card-title class="justify-center mt-n2">
                      <span class="input-group-product">
                        {{ item.product.group }}
                      </span>
                    </v-card-title>

                    <v-card-text>
                      <v-row align="center" class="mx-0">
                        <v-rating
                          :value="item.product.average_star ? item.product.average_star : 5"
                          color="secondary"
                          dense
                          half-increments
                          readonly
                          size="16"
                        ></v-rating>
                      </v-row>

                      <div class="my-3 product-name">
                        <span class="input-name-product" @click="productImageSelected(item)">
                          {{ item.product.name }}
                        </span>
                      </div>
                    </v-card-text>

                    <v-card-title class="mt-n10">
                      <v-row no-gutters>
                        <template v-if="item.product.off">
                          <v-col cols="3" sm="4" xs="4">
                            <v-card class="pa-0 ma-0 text-left" style="border: 0" outlined elevation="0">
                              <img :src="require('@/assets/logo.png')" alt="Dino Toys" width="45">
                            </v-card>
                          </v-col>
                          <v-col cols="9" sm="8" xs="8">
                            <v-card class="pa-0 ma-0 text-right conetnido" style="border: 0" outlined elevation="0">
                              <v-chip
                                v-if="displayProductOff"
                                color="pink"
                                label
                                text-color="white"
                              >
                                - {{ item.product.off }}%
                              </v-chip>
                              S/ {{ item.product.sale_price }}
                            </v-card>
                            <v-card class="pa-0 ma-0 body-2 text-right" style="border: 0" outlined elevation="0">
                              S/ {{ item.product.regular_price }}
                            </v-card>
                          </v-col>
                          <!-- <v-col cols="12" sm="12" xs="6">
                            <v-card class="pa-0 ma-0 text-right" style="border: 0" outlined elevation="0">
                              <v-chip
                                color="pink"
                                label
                                text-color="white"
                              >
                                <v-icon left>
                                  mdi-label
                                </v-icon>
                                - {{ item.product.off }}%
                              </v-chip>
                            </v-card>
                          </v-col> -->
                        </template>
                        <template v-else>
                          <v-col cols="6" sm="4" xs="4">
                            <v-card class="pa-0 ma-0 text-left" style="border: 0" outlined elevation="0">
                              <img :src="require('@/assets/logo.png')" alt="Dino Toys" width="45">
                            </v-card>
                          </v-col>
                          <v-col cols="6" sm="8" xs="8">
                            <v-card class="pa-0 ma-0 text-right" style="border: 0" outlined elevation="0">
                              S/ {{ item.product.regular_price }}
                            </v-card>
                            <v-card class="pa-0 ma-0 body-2 text-right" style="border: 0" outlined elevation="0">
                              &nbsp;
                            </v-card>
                          </v-col>
                          <!-- <v-col cols="12" sm="12" xs="6">
                            <v-card class="pa-0 ma-0 body-2 text-right" style="border: 0" outlined elevation="0">
                              <v-chip
                                color="white"
                                label
                                text-color="white"
                              >
                                <v-icon left>
                                  mdi-label
                                </v-icon>
                                &nbsp;
                              </v-chip>
                            </v-card>
                          </v-col> -->
                          <!-- <v-col cols="12" sm="12" xs="12">
                            <v-card class="pa-0 ma-0 text-right" style="border: 0" outlined elevation="0">
                              &nbsp;
                            </v-card>
                          </v-col> -->
                        </template>
                      </v-row>
                    </v-card-title>
                  </v-card>
                </v-col>
              </template>
            </v-row>

            <v-row justify="center" class="pt-8 pb-8">
              <v-pagination v-model="page" :length="length"></v-pagination>
            </v-row>

            <v-row>
              <v-col cols="12" md="12" class="text-right">
                <v-btn
                  :disabled="disabledSubmit"
                  color="primary"
                  block
                  depressed
                  @click="generateImages()"
                >
                  Generar Imagenes
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>

      <template>
        <div class="text-center ma-2">
          <v-snackbar
            timeout="7000"
            v-model="snackbar"
            :color="color"
            top
            z-index="500"
          >
            {{ text }}
            <template v-slot:action="{ attrs }">
              <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="snackbar = false"
              >
                X
              </v-btn>
            </template>
          </v-snackbar>
        </div>
      </template>

      <template>
        <div class="text-center">
          <v-overlay :value="overlay" z-index="500">
            <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="primary"
            ></v-progress-circular>
          </v-overlay>
        </div>
      </template>

    </section>
  </default-layout>
</template>
<script>
  import Vue from 'vue'
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'
  import html2canvas from 'html2canvas';

  axios.defaults.baseURL = process.env.DINO.ENDPOINT;

  export default {
    name: 'ProductsImage',
    components: {
      DefaultLayout
    },
    data () {
      return {
        overlay: false,
        disabledSubmit: true,
        groupSelected: null,
        productColors: [],
        page: 1,
        length: null,
        count: 10,
        orderBy: null,
        select: {
          groups: [
            { id: 'HOT WHEELS', name: 'HOT WHEELS' },
            { id: 'JURASSIC WORLD', name: 'JURASSIC WORLD' },
            { id: 'MINECRAFT', name: 'MINECRAFT' },
            { id: 'THOMAS & FRIENDS', name: 'THOMAS & FRIENDS' },
            { id: 'ANGRY BIRDS', name: 'ANGRY BIRDS' },
            { id: 'CHOMP SQUAD', name: 'CHOMP SQUAD' },
            { id: 'BLAZE', name: 'BLAZE' },
            { id: 'SMASHERS', name: 'SMASHERS' },
            { id: 'MUÑECAS', name: 'MUÑECAS' },
            { id: 'NINTENDO SWITCH', name: 'NINTENDO SWITCH' },
            { id: 'NERF', name: 'NERF' },
            { id: 'PLAY DOH', name: 'PLAY DOH' },
            { id: 'SUPER MARIO', name: 'SUPER MARIO' },
            { id: 'PRINCESAS', name: 'PRINCESAS' },
            { id: 'FRIEND', name: 'FRIEND' },
            { id: 'DIDACTICOS', name: 'DIDACTICOS' },
            { id: 'MOCHILAS, CARTUCHERAS Y LONCHERAS', name: 'MOCHILAS, CARTUCHERAS Y LONCHERAS' },
            { id: 'ÚTILES', name: 'ÚTILES' },
            { id: 'MAQUILLAJE', name: 'MAQUILLAJE' },

            { id: 'MENAJES', name: 'MENAJES' },
            { id: 'MAMALONCHERITA', name: 'MAMÁ LONCHERITA' },
            { id: 'BELLEZA', name: 'BELLEZA' },
            { id: 'ELECTROHOGAR', name: 'ELECTROHOGAR' },
            { id: 'DEVUELTAALCOLE', name: 'DE VUELTA AL COLE' },
            { id: 'PELUCHESINTERACTIVOS', name: 'PELUCHES INTERACTIVOS' },
            { id: 'DINO', name: 'DINO' },
            { id: 'PAWPATROL', name: 'PAW PATROL' },
            { id: 'BLUEY', name: 'BLUEY' },
            { id: 'SUPERMARIO', name: 'SUPER MARIO' },
            { id: 'JUGUETES', name: 'JUGUETES' },
            { id: 'JUEGOSFAMILIARES', name: 'JUEGOS FAMILIARES' },
            { id: 'BLOQUES', name: 'BLOQUES' },
            { id: 'MUNDOBEBE', name: 'MUNDO BEBE' },
            { id: 'NAVIDAD', name: 'NAVIDAD' }
          ],
          filters: [
            { id: 'OrderByPriceASC', name: 'Precio más bajo' },
            { id: 'OrderByPriceDESC', name: 'Precio más alto' },
            { id: 'OrderByReleaseDateDESC', name: 'Lo más nuevo' },
            { id: 'OrderByBestDiscountDESC', name: 'Mejor descuento' }
          ],
        },
        displayProductOff: false,
        // ************ snackbar ************
        snackbar: false,
        text: '',
        color: 'green',
        // **********************************
      }
    },
    computed: {
      shownCards () {
        window.scrollTo(0, 0);
        const { page, count, productColors } = this;
        const number = Math.ceil(productColors.length / count);
        return productColors.slice((page - 1) * count, page * count);
      }
    },
    methods: {
      showMessage(text, color) {
        this.snackbar = true;
        this.text = text;
        this.color = color;
      },

      findProduct() {
        const filter = this.$route.query.q ? this.$route.query.q : this.groupSelected;
        let url = process.env.DINO.PATH.GET_PRODUCTS_SEARCH + filter + (this.orderBy ? '&orderBy=' + this.orderBy : '');
        axios.get(url)
        .then(response => {
          this.page = 1;
          this.productColors = response.data;
          this.length = Math.ceil(response.data.length / this.count);
          this.disabledSubmit = response.data.length > 0 ? false : true;
        })
        .catch(err => {

        });
      },

      generateImages() {
        this.disabledSubmit = true;
        this.showMessage('Generando imágenes, esperar por favor...', 'green');
        this.shownCards.forEach((value, index) => {
          const canvas = html2canvas(this.$refs[value.id][0], {
            scale: 5,
            allowTaint : false,
            useCORS: true,
            proxy: "https://firebasestorage.googleapis.com/v0/b/dino-toys.appspot.com"
          }).then(canvas => {
            const link = document.createElement('a')
            link.download = value.product.name + '.jpg'
            link.href = canvas.toDataURL()
            link.click()
          });
        });
        setTimeout(() => this.disabledSubmit = false, 7000);
      }
    },
    mounted: function() {
      axios.defaults.headers = {
        'authorization': localStorage.getItem('authorization')
      };
    },
    watch: {
      '$route.query.q'(val) {
        if (val) {
          this.findProduct();
        }
      },
      'groupSelected'(val) {
        if (val) {
          this.findProduct();
        }
      }
    }
  }
</script>
<style scoped>
  .product-name {
    width: 100%;
    height:45px;
    color:black;
    overflow:hidden;
    text-overflow: ellipsis;
  }

  .btn-add-cart {
    width: 100%;
    font-size: 11px !important
  }

  .input-price >>> input[type='number'] {
    -moz-appearance:textfield;
    text-align: center;
  }

  .input-price >>> input::-webkit-outer-spin-button,
  .input-price >>> input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    text-align: center;
  }

  .input-group-product {
    font-size: 14px;
    color: #777;
    text-transform: uppercase
  }

  .input-name-product {
    font-size: 14px;
    text-transform: uppercase
  }

  .conetnido {
    font-size: 90%;
    @media only screen and (min-width: 600px) {
        font-size: 94%;
    }
    @media only screen and (min-width: 1000px) {
        font-size: 98%;
    }
    @media only screen and (min-width: 1200px) {
        font-size: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/marketing/ProductsImage.vue